import Helper from './Helper';

class Accordion {
  constructor(config = {}) {
    const {
      accordions,
    } = config;
    this.trigger = accordions;
    this.accordions = Array.prototype.slice.call(document.querySelectorAll(accordions));
    this.currentEl = null;
    if(this.accordions && this.accordions.length !== 0){
      this.bindEvents();
    
      const url = location.href;

      const id = url.split('#');
      if(id[1]){
        const realID = id[1].replace('note-', '');
        const accordionToClick = document.querySelector('#accordion'+realID);
        if(accordionToClick){
        if(!accordionToClick.classList.contains('no-parent')){
          const accordionParentToClick = Helper.getParentNodeWithClass(accordionToClick, 'accordion--level-1').querySelector('h3.js-accordion-trigger');
          if(accordionParentToClick){
            accordionParentToClick.click();
          }
        }
        setTimeout( () => {
            accordionToClick.click();
          }, 500);
        }
      }
    }
  }

  bindEvents() {
    this.accordions.forEach(el => {
      el.addEventListener('click', (e) => {
        this.clickHandler(el);
        if(el.classList.contains('active')){
          this.close(el);
        } else{
          this.open(el);
        }
      });
    });


  }

  clickHandler(el){
    if(el.parentNode.classList.contains('accordion--level-2')){
      if(!el.classList.contains('active')){
        let el4 = document.querySelector('.accordion--level-2 > '+this.trigger+'.active');
        this.close(el4);
      }
    } else if(el.parentNode.classList.contains('accordion--level-1')) {
      if(el.classList.contains('active')){
        let el3 = el.nextElementSibling.querySelector(this.trigger+'.active');
        this.close(el3);
      } else{
        let el2 = document.querySelector(this.trigger+'.active');
        this.close(el2);
        if(el2){ 
          let el6 = el2.nextElementSibling.querySelector(this.trigger+'.active')
          this.close(el6);
        }
      }
    }

    setTimeout(() => {this.scrollTo()}, 500);
  }

  close(el){
    if(el){
      Helper.slideClose(el.nextElementSibling);
      el.classList.remove('active');
    }
  }

  open(el){
    if(el){
      el.classList.add('active');
      Helper.slideOpen(el.nextElementSibling, true);
    }
  }

  scrollTo(){

      let el = null;
      let el_level2 = document.querySelector('.accordion--level-2 > '+this.trigger+'.active');
      let el_level1 = document.querySelector('.accordion--level-1 > '+this.trigger+'.active');

      if(el_level2){
        el = el_level2;
      } else if(el_level1){
        el = el_level1;
      }

      if(el){
        window.scrollTo({
          top: Helper.getOffsetTop(el) - 126 + window.scrollY,
          left: 0,
          behavior: 'smooth'
        });
        
      }
  }

}

export default Accordion;
